<template>
  <div>
    <div style="margin-bottom:10px; margin-left:20px">
      <a-breadcrumb>
        <a-breadcrumb-item href>
          <a-icon type="home"/>
        </a-breadcrumb-item>
        <a-breadcrumb-item>
          <router-link :to="{name: from && from.link}" style>
            <a-icon :type="from && from.type ? from.type : 'share-alt'"/>
            <span style="padding-left:4px">{{from && from.name}}</span>
          </router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item>{{to && to.name}}</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    from: Object,
    to: Object
  }
};
</script>
